import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Features from "../components/features";

function Home() {
  return (
    <div className="home-page">
      <Navbar />
      <main>
        <Hero />
        <Features />
      </main>
      <div className="home-copyright">
        © 2026 AiDuNode · Universitas Negeri Malang · Built with ❤️ in Indonesia
      </div>
    </div>
  );
}

export default Home;